import { HOY, masDias } from "../general";

// clase Proyecto
class Proyecto {
  constructor(id = "", nombre = "", pm = "", fechaRegistro = HOY, prioridad = "", descripcion = "") {
    this.id = id;
    this.nombre = nombre;
    this.pm = pm;
    this.fechaRegistro = fechaRegistro;
    this.prioridad = prioridad;
    this.descripcion = descripcion;
    this.estado = {
      semaforo: "Rojo",
      alcance: "Rojo",
      cronograma: "Rojo",
      recursos: "Rojo",
    };
    this.fechaEvaluacion = "";
    this.tipo = "";
    this.activo = true;
  }

  inicializarConRegistroDB(p) {
    this.id = p.id;
    this.nombre = p.nombre;
    this.pm = p.pm;
    this.fechaRegistro = p.fechaRegistro;
    this.prioridad = p.prioridad;
    this.descripcion = p.descripcion;
    this.estado = { ...p.estado };
    this.fechaEvaluacion = p.fechaEvaluacion;
    this.tipo = p.tipo;
    this.activo = p.activo;
  }
}

class Usuario {
  constructor(id = "", nombre = "", email = "", horassemana = 0, rol = "usuario", foto = "", passw = "", url = "") {
    this.id = id;
    this.nombre = nombre;
    this.email = email;
    this.horassemana = horassemana;
    this.rol = rol;
    this.foto = foto;
    this.url = url;
    this.passw = passw;
  }
  inicializarConRegistroDB(u) {
    this.id = u.id;
    this.nombre = u.nombre;
    this.email = u.email;
    this.horassemana = u.horassemana;
    this.rol = u.rol;
    this.foto = u.foto;
    this.url = u.url;
    this.passw = u.passw;
  }
}

class Actividad {
  constructor(
    proyecto = "",
    id = "ACT000",
    nombre = "",
    inicio = HOY,
    finEstimado = masDias(HOY, 30),
    estado = "",
    progreso = 0,
    horas = 0,
    puntos = 0,
    color = "#A9F5BC",
    asignados = [],
    files = [],
    orden = 0,
    stories = []
  ) {
    this.proyecto = proyecto;
    this.id = id;
    this.nombre = nombre;
    this.inicio = inicio;
    this.finEstimado = finEstimado;
    this.estado = estado;
    this.progreso = progreso;
    this.horas = horas;
    this.puntos = puntos;
    this.color = color;
    this.asignados = asignados; // es de tipo usuario
    this.files = files;
    this.orden = orden;
    this.stories = stories
  }

  shiftAsignados() {
    if (this.asignados.length !== 0) {
      this.asignados.push(this.asignados.shift());
    }
  }

  shiftAdjuntos() {
    if (this.files.length !== 0) {
      this.files.push(this.files.shift());
    }
  }

  inicializarConRegistroDB(a) {
    this.proyecto = a.proyecto;
    this.id = a.id;
    this.nombre = a.nombre;
    this.inicio = a.inicio;
    this.finEstimado = a.finEstimado;
    this.estado = a.estado;
    this.progreso = a.progreso;
    this.horas = a.horas;
    this.puntos = a.puntos;
    this.color = a.color;
    this.asignados = a.asignados ? [...a.asignados] : []; // es de tipo usuario
    this.files = a.files ? [...a.files] : [];
    this.orden = a.orden;
    this.stories = a.stories ? [...a.stories] : []
  }

  copia() {
    let a = new Actividad();
    a.proyecto = this.proyecto;
    a.id = this.id;
    a.nombre = this.nombre;
    a.inicio = this.inicio;
    a.finEstimado = this.finEstimado;
    a.estado = this.estado;
    a.progreso = this.progreso;
    a.horas = this.horas;
    a.puntos = this.puntos;
    a.color = this.color;
    a.asignados = [...this.asignados];
    a.files = [...this.files];
    a.orden = this.orden;
    a.stories = [...this.stories];
    return a;
  }

  usuarioAsignado(usr) {
    for (let i = 0; i < this.asignados.length; i++) {
      if (this.asignados[i].id === usr) return true
    }
    return false;
  }

}

class Adjunto {
  constructor(id = "", nombre = "", url = "") {
    this.id = id;
    this.nombre = nombre;
    this.url = url;
  }
}

class Riesgo {
  constructor(proyecto = "", id = "", descripcion = "", prioridad = "Alto") {
    this.id = id;
    this.proyecto = proyecto;
    this.descripcion = descripcion;
    this.estado = "abierto";
    this.inicio = HOY;
    this.fechaCierre = 0;
    this.prioridad = prioridad;
    this.responsable = ""
  }
}

class Cambio {
  constructor(proyecto = "", id = "", descripcion = "") {
    this.proyecto = proyecto;
    this.id = id;
    this.descripcion = descripcion;
    this.estado = "pendiente";
    this.inicio = HOY;
    this.fechaCierre = 0;
    this.adjunto = { url: "", nombre: "" };
  }
}

class Accion {
  constructor(proyecto = "", id = "", descripcion = "") {
    this.proyecto = proyecto;
    this.id = id;
    this.descripcion = descripcion;
    this.estado = "pendiente";
    this.inicio = HOY;
    this.finEstimado = 0;
    this.prioridad = "Alta";
    this.dimension = "alcance";
    this.responsable = "";
  }
}

class ItemHora {
  constructor(semana = "", persona = "", id = "", nombre = "", tipo = "") {
    this.semana = semana;
    this.persona = persona;
    this.id = id;
    this.nombre = nombre;
    this.tipo = tipo;
    this.horas = [0, 0, 0, 0, 0, 0, 0];
  }
}

class Permisos {
  constructor() {
    this.administracion = false;
    this.registroHoras = false;
    this.altaCambio = false;
    this.altaProyecto = false;
    this.altaRiesgo = false;
    this.modificarProyectoPropio = false;
    this.modificarProyectoAjeno = false;
    this.eliminarAdjunto = false;
    this.altaIncidente = false;
    this.actualizarIncidenteAjeno = false;
    this.planificarIncidentes = false;
    this.rol = "";
  }
}

class Evaluacion {
  constructor() {
    this.id = "Alcance";
    this.impacto = "rojo";
    this.pregunta = "?";
    this.respuesta = "n";
  }
}

class Incidente {
  constructor(usuarioRegistro = "") {
    this.id = "...nuevo...";
    this.tipo = "";
    this.prioridad = "Baja";
    this.descripcion = "";
    this.estado = "pendiente";
    this.fechaRegistro = HOY;
    this.fechaCierre = 0;
    this.finEstimado = 0;
    this.horas = 4;  // minimo de horas para un mantenimiento
    this.categoria = "";
    this.responsable = "ZZZ";   // usuario que refleja no asignacion
    this.adjunto = { url: "", nombre: "" };
    this.usuarioRegistro = usuarioRegistro;
  }

  inicializarConRegistroDB(i) {
    this.id = i.id;
    this.tipo = i.tipo;
    this.prioridad = i.prioridad;
    this.descripcion = i.descripcion;
    this.estado = i.estado;
    this.fechaRegistro = i.fechaRegistro;
    this.fechaCierre = i.fechaCierre;
    this.finEstimado = i.finEstimado;
    this.horas = i.horas;
    this.categoria = i.categoria;
    this.responsable = i.responsable ? i.responsable : "";
    this.adjunto = i.adjunto ? { ...i.adjunto } : { url: "", nombre: "" };
  }
}

class LogIncidente {
  constructor(idIncidente = "", responsable = "") {
    this.id = "...nuevo...";
    this.idIncidente = idIncidente;
    this.log = "";
    this.fecha = HOY;
    this.responsable = responsable;
  }

  inicializarConRegistroDB(l) {
    this.id = l.id;
    this.idIncidente = l.idIncidente;
    this.log = l.log;
    this.fecha = l.fecha;
    this.responsable = l.responsable;
  }
}

class Tarea {
  constructor(tipo = "", id = "", descripcion = "", finEstimado = "", prioridad = "", proyecto = "") {
    this.tipo = tipo;
    this.id = id;
    this.descripcion = descripcion;
    this.finEstimado = finEstimado;
    this.prioridad = prioridad;
    this.proyecto = proyecto;
  }
}


class Story {
  constructor(
    proyecto = "",
    id = "...nueva...",
    sprint = "",
    nombre = "",
    descripcion = "",
    estado = "pendiente",
    tipo = "funcionalidad",
    prioridad = "Baja",
    horas = 0,
    puntos = 0,
    color = "#F8E0F7",
    asignados = [],
    files = [],
  ) {
    this.proyecto = proyecto;
    this.id = id;
    this.sprint = sprint;
    this.nombre = nombre;
    this.descripcion = descripcion;
    this.estado = estado;
    this.tipo = tipo;
    this.prioridad = prioridad;
    this.horas = horas;
    this.puntos = puntos;
    this.color = color;
    this.asignados = [...asignados]; // es de tipo usuario
    this.files = [...files];
  }

  inicializarConRegistroDB(s) {
    this.proyecto = s.proyecto;
    this.id = s.id;
    this.sprint = s.sprint;
    this.nombre = s.nombre;
    this.descripcion = s.descripcion;
    this.estado = s.estado;
    this.tipo = s.tipo;
    this.prioridad = s.prioridad;
    this.horas = s.horas;
    this.puntos = s.puntos;
    this.color = s.color;
    this.asignados = s.asignados ? [...s.asignados] : []; // es de tipo usuario
    this.files = s.files ? [...s.files] : [];
  }
}

export { Proyecto, Usuario, Actividad, Adjunto, Riesgo, Cambio, Accion, ItemHora, Permisos, Evaluacion, Incidente, LogIncidente, Tarea, Story };
